import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auto-search-wrapper" }
const _hoisted_2 = { class: "icon-form-control" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-poi text-primary icon-form-control__icon",
  "aria-hidden": "true"
}, null, -1)

import { ref, onMounted, nextTick } from 'vue';

    import Autocomplete from '../../libs/autocomplete.esm.js';
    import axios from "axios";
    import {trackSearch} from "../utils/utils";

    import {useBookingDataStore} from "../stores/BookingDataStore";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Autosuggest',
  props: {
        baseUri: {
            type: String,
            required: false,
            default: '/de/rent-shop/locations/search/get-suggestions'
        },
    },
  emits: ['selectLocation'],
  setup(__props, { emit }) {

const props = __props;

    const bookingDataStore = useBookingDataStore();

    

    const locationSearch = ref(null);

    const defaultOptions = {
        uri: '/rent2022/static/examples/widget-search-response.json',
        wildcard: '%QUERY%',
        //paramName: 'searchTerm'
        paramName: 'q'
    };

    

    const getAutoCompleteUrl = ( baseUri, wildcard, queryParamName ) => {
        let url = baseUri;
        let qs = null;
        if( baseUri.includes('?') ) {
            [ url, qs ] = baseUri.split('?', 2 );
        }
        let params = new URLSearchParams( qs );
        if( params.has( queryParamName ) ) {
            params.delete( queryParamName )
        }
        let remoteUrl = url;
        if( Array.from(params.keys()).length ) {
            remoteUrl += '?' + params.toString();
            remoteUrl += '&' + queryParamName + '=' + wildcard;
        } else {
            remoteUrl += '?' + queryParamName + '=' + wildcard;
        }
        return remoteUrl;
    };

    let content = "Hello World";
    let lastMatches;



    onMounted(() =>  {
        //let remoteUrl;
        // data-autocomplete-remote-url="/static/json/autocomplete-result.json?searchTerm=%QUERY%"
        //remoteUrl = '/rent2022/static/examples/widget-search-response.json?searchTerm=%QUERY%';
        //remoteUrl = '/de/rent-shop/locations/get-suggestions?q=%QUERY%';

        let wildcard = defaultOptions.wildcard;
        let queryParamName = defaultOptions.paramName;

        let baseUri = props.baseUri;

        let remoteUrl = getAutoCompleteUrl( baseUri ?? defaultOptions.uri, wildcard, queryParamName );

        new Autocomplete(locationSearch.value, {
            clearButton: false,
            onSearch: ({ currentValue }) => {
                const api = remoteUrl.replace(wildcard, encodeURIComponent(currentValue));
                return axios.get(api)
                    .then((response) => {
                        return response.data;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            howManyCharacters: 3,
            onResults: ({ matches: result, currentValue }) => {

                // currentValue is the queryTerm
                if (bookingDataStore.eventTracking) {
                    trackSearch( currentValue, 'suggest' );
                }

                lastMatches = [];
                let resultStrings = [];

                resultStrings.push(result.results.groups.map((item) => {

                    // group
                    const title = item.title;
                    let tempItems = '';


                    // header
                    let header = `<div class="autocomplete__dataset-header">
                                    <div class="autocomplete__dataset-header-hl">${title}</div>
                                  </div>`;

                    tempItems = item.items.map((data, index, array) => {
                        // create the regex for the highlight
                        // let regexp = new RegExp(currentValue, 'gi');
                        lastMatches.push(data);
                        let mainItem = `<div class="autocomplete__suggestion autocomplete__selectable js-autocomplete__item">
                                    <div class="font-medium">${data.title}</div>
                                    <div>
                                        <span class="hit-flag hit-flag-${data.country}" aria-label="${data.country}"></span>
                                        ${data.info}
                                    </div>
                                </div>`;

                        if (data?.items?.length) {
                            // subItems have a bit of a different structure - the name is directly next to the info
                            let subItems = data.items.map((subitem) => {
                                lastMatches.push(subitem);
                                return `<div class="autocomplete__suggestion autocomplete__selectable js-autocomplete__item">
                                            <div>
                                                <span class="hit-flag hit-flag-${subitem.country}" aria-label="${subitem.country}"></span>
                                                ${subitem.info}<span class="font-medium">${subitem.title}</span>
                                            </div>
                                        </div>`;
                            }).join('');
                            mainItem += `<div class="autocomplete__subitems">${subItems}</div>`;
                        }

                        return mainItem;

                    }).join('');


                    return `<div class="autocomplete__dataset">${header}<div class="autocomplete__item-group">${tempItems}</div></div>`;


                }).join(""));

                let messageMarkup = `<div class="autocomplete__message">${result.message.content}</div>`;

                return result.results?.amount === 0 ? messageMarkup : resultStrings.join("");
            },
            onSubmit: ({ index, element, object, results }) => {
                let match = lastMatches[index];
                if (bookingDataStore.eventTracking) {
                    trackSearch(match.title, 'select');
                }

                // if the item has an alternate path, redirect to it (e.g. for cities without a shop on the .com)
                if ( match?.alternate.enabled && match?.alternate.path ) {
                    window.location.href = match.alternate.path;
                    // do not set the selected location in the store afterwards (in the time where the new location.href loads),
                    // because it would show the calendar. Because of the BF-cache, the calendar would still be shown on back-button-click.
                } else {
                    // set the selected location in the store
                    emit('selectLocation', lastMatches[index]);
                }
            },

        });
        nextTick(() => {
            // focus the input when mounted
            locationSearch.value.focus();
        });
    })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        class: "form-control booking-widget__form-control",
        ref_key: "locationSearch",
        ref: locationSearch
      }, null, 512),
      _hoisted_3
    ])
  ]))
}
}

})